import { Fragment } from "react";
import Home from "./Home";

function Preferences() {
  return (
    <Fragment>
      <Home />
    </Fragment>
  );
}

export default Preferences;
